<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t("report.template.templateList") }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/report/reportTemplateList"><span>{{$t('tlt.reportTemplate')}}</span></router-link></li>                    
                </ul>                
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('reportTemplate')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form class="row">
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("report.template.templateName") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="templateNameFilter"/>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("report.template.templateType") }}:
                                    </label>
                                    <select class="form-control"  v-model="templateTypeFilter">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option v-for="(item,index) in templateTypeList" :value="item" :key=index>{{item}}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("report.template.templateFileName") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="templateFileNameFilter"/>
                                </div>
                                <div class="form-group col-md-2"></div>
                                <div class="col-lg-4 align-self-end">
                                    <div class="float-lg-right">
                                        <button class="btn btn-outline-secondary mr-1" type="button" 
                                         v-on:click="MMFClearFilter('reportTemplate')">
                                            <i class="fa fa-fw fa-lg fa-eraser"></i>
                                            <span class="text">{{ $t("btn.basic.clear") }}</span>
                                        </button>
                                        <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('reportTemplate')">
                                            <i class="fa fa-fw fa-lg fa-search"></i>
                                            <span class="text">{{ $t("btn.basic.search") }}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="reportTemplateTable" class="content">
                <div class="card my-1">
                    <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionResult"
                        >
                        <div class="card-body">
                            <mmf-table  entity="reportTemplate"
                                        inline-actions-disabled singleChoice>
                                <div slot="btnList" class="btn-group">
                                    <button class="btn btn-outline-primary" v-on:click="showRuntimeParamConfig()" :disabled="isDisable">
                                        <i class="fa fa-play-circle" aria-hidden="true"></i>
                                        <span class="text">{{ $t("report.template.generateReport") }}</span>
                                    </button>
                                </div>
                                <div slot="btnList" class="btn-group">
                                    <button class="btn btn-outline-primary" v-on:click="autoReport()" :disabled="!isResumeAble()">
                                        <i class="fa fa-play-circle" aria-hidden="true"></i>
                                        <span class="text">{{ $t("report.template.autoReport") }}</span>
                                    </button>
                                </div>
                                <div slot="btnList" class="btn-group">
                                    <button class="btn btn-outline-primary" v-on:click="stopAutoReport()" :disabled="!isPauseAble()">
                                        <i class="fa fa-play-circle" aria-hidden="true"></i>
                                        <span class="text">{{ $t("report.template.stopAutoReport") }}</span>
                                    </button>
                                </div>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <report-template-config ref="templateConfig" :runtimeParam="checkedEntity.runtimeParam" @changeRunParam="changeRunParam" @generateReport="generateReport()"></report-template-config>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import { filterFields}  from "@/model/report/ReportTemplate";
import MmfTable from "@/components/MmfTable";
import ReportTemplateConfig from '@/views/report/ReportTemplateConfig';
import _ from 'lodash';

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
    getterType: 'reportTemplate/getField',
    mutationType: 'reportTemplate/updateField',
});

export default {
  name: "reportTemplateList",
  data () {
    return {
      
    }
  },
  components: { MmfTable, ReportTemplateConfig },
  computed: {
        // generate and add getters and setters using the filter names defined in
        // entity model
        ...mapFields(filterFields),
        ...mapState({
            templateTypeList: state => state.reportTemplate.templateTypeList,
            checkedItems: state => state.reportTemplate.checkedItems,
            checkedEntity: state => state.reportTemplate.entity,
            rows: state => state.reportTemplate.rows,
            isDisable() {
                return this.checkedItems.length != 1;
            }
        })
  },
  methods: {
    isPauseAble() {
        if(this.checkedItems.length <= 0)
            return false;
        for(var id of this.checkedItems) {
            let item = this.rows.filter(row => row['id'] == id);
            if(item[0].scheduleStatus == 0)
                return false
        }
        return true
    },
    isResumeAble() {
        if(this.checkedItems.length <= 0)
            return false;
        for(var id of this.checkedItems) {
            let item = this.rows.filter(row => row['id'] == id);
            if(item[0].scheduleStatus == 1)
                return false
        }
        return true
    },
    autoReport(){
        this.$store.dispatch("reportTemplate/autoReport", this.checkedItems)
    },
    stopAutoReport(){
        this.$store.dispatch("reportTemplate/stopAutoReport", this.checkedItems)
    },
    changeRunParam(runParam){
        this.$store.commit("reportTemplate/setRuntimeParam", JSON.stringify(runParam))
    },
    generateReport() {
        this.$store.dispatch('reportTemplate/generateReport', this.checkedEntity);
    },
    showRuntimeParamConfig() {
        this.$refs.templateConfig.show();
    },
    ...mapActions("reportTemplate", ["getAllTemplateType"]),
    ...mapActions("base", ["MMFselectRow", "MMFselectAllRows", "MMFNew", 
    "MMFEdit", "MMFLoadRows", "MMFDelete", "MMFClearFilter"]),
    
  },
  mounted(){
      this.$store.dispatch('reportTemplate/getAllTemplateType');
      
  }
};
</script>
